/** 3Dの演出（ダイス ㉛c1〜c4・印 ㉜）。重い three / cannon-es は初回の呼び出しまで読み込まない */
import type { DiceRollRequest, Fx } from '../tabs/contract';

export function createFx(asset: (p: string) => string): Fx {
  let preloading: Promise<void> | null = null;
  return {
    async rollDice(host: HTMLElement, req: DiceRollRequest): Promise<void> {
      const { rollDice } = await import('./dice');
      return rollDice(asset, host, req);
    },
    async pressSeal(target: HTMLElement, opts?: { quick?: boolean }): Promise<void> {
      const { pressSealTool } = await import('./seal');
      return pressSealTool(asset, target, opts?.quick === true);
    },
    preload(): Promise<void> {
      if (preloading) return preloading;
      const p = (async () => {
        try {
          const [{ loadDie }, { loadSprites }, { preloadTool }] = await Promise.all([import('./die-model'), import('./sprites'), import('./seal')]);
          await Promise.all([loadDie(asset), loadSprites(asset), preloadTool(asset)]);
        } catch {
          /* 読めなくても投げる・押すときに退避の表示へ回る */
        }
      })();
      preloading = p;
      return p;
    },
  };
}
